import * as React from 'react';
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Typography, FormControl, FormControlLabel, InputLabel, Select, MenuItem, Grid, Checkbox} from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useMediaQuery, useTheme } from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import useAlert from "@hooks/useAlert";
import moment from 'moment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ManagerAttdncPartMany from './manager-attdnc.part.many';

const dayMap = {
  S001: '월',
  S002: '화',
  S003: '수',
  S004: '목',
  S005: '금',
  S006: '토',
  S007: '일',
}

const iFormat= 'YYYY-MM-DD HH:mm:ss';
const defSmst = {id:-1, year:'', gisu: ''}
const ALL = '전체'
const ManagerAttdncPartChoice = ({dialogHandler, isCurrent}) =>  {
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)
  const [smstList, set_smstList] = useState([])
  const [monthList, set_monthList] = useState([])
  const gradeList = [ALL, '1', '2', '3', '4', '5', '6']
  const [grade, set_grade] = useState(ALL)
  const [classNameList, set_classNameList] = useState([])
  const [className, set_className] = useState(ALL)
  const [month, set_month] = useState()
  const [smst, set_smst] = useState(defSmst)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const manyHandler = useState(false)
  const {alert, renderAlert} = useAlert()
  const [smstId, set_smstId] = useState(-1)
  const [period, set_period] = useState(0)
  const [fillEmpty, set_fillEmpty] = useState(false)
  const [hidePhone, set_hidePhone] = useState(false)
  const [targetDate, set_targetDate] = useState(null)
  const [targetDate2, set_targetDate2] = useState(null)
  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {
      dialogHandler[1](false)
    }
  }

  const getMonthsBetween = (startDate, endDate) => {
    const months = [];
    let currentDate = moment(startDate, iFormat).startOf('month');
    while (currentDate.isSameOrBefore(endDate)) {
        months.push(currentDate.format('YYYY-MM'));
        currentDate.add(1, 'month');
    }
    return months;
  }

  const getClassNames = (smst) => {
    const classNames = []
    smst.lectures.forEach(lecture => {
      lecture.students.forEach(student=> {
        const found = classNames.find(r => r === student.className)
        if(!found) {
          classNames.push(student.className)
        }
      });
    })
    classNames.sort((a,b) => a.localeCompare(b) )
    classNames.unshift(ALL)
    return classNames
  }

  const fetchSmst = async (smstId) => {
    const url = `/attdnc/download/excel/smst/${smstId}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const smst = JSON.parse(repMessage.smst)

    smst.lectures.forEach(lecture => {
      let schedule = '' 
      const lschs = lecture.lschs
      lschs.forEach(lsch => {
        const day = dayMap[lsch.weekCode]
        const stime = lsch.startTime
        const etime = lsch.endTime
        schedule += `${day} ${stime}~${etime}` 
        schedule +=  ',' 
      })
      schedule = schedule.endsWith(',') ? schedule.slice(0, -1) : schedule
      lecture.schedule = schedule
    })

    return smst
  }

  const onChangeSmstId = async (smstId) => {
    const vaniaSmst = smstList.find(r => r.id === smstId) 

    if(vaniaSmst) {
      const smst = await fetchSmst(vaniaSmst.id) 
      // const classNames = getClassNames(smst)
      // set_classNameList(classNames)
      set_smst(smst)

      const monthList = getMonthsBetween(vaniaSmst.lectureStime, vaniaSmst.lectureEtime)
      set_monthList(monthList)

      const classNames = getClassNames(smst)
      set_classNameList(classNames)
      set_className(ALL)

      set_grade(ALL)
    }
  }

  const fetchSmstList = async() => {
		// const url = `/smst/attdnc/${schola.id}`
		const url = `/smst/${schola.id}`
    openIndicator()
		const resp = await WebService.get(url, {})
    closeIndicator()
		if (resp.repCode !== "ack") {
			alert(resp.repMessage)
			return
		}

		const repMessage = JSON.parse(resp.repMessage)
		const smstList = JSON.parse(repMessage.records)
    // return smstList.filter(r => +r.phase != 2)
    const filtered = smstList.filter(r => +r.phase >= 1.3)

    if(isCurrent) {
		  return filtered.filter(r => +r.phase != 2)
    }
    else {
		  return filtered.filter(r => +r.phase == 2)
    }
  }

  const onChangeTargetDate = async(date) => {
    const dt = moment(date, iFormat).format('YYYY-MM-DD')
    set_targetDate(dt)
    if(targetDate2 == null) {
      set_targetDate2(dt)
    }
  }

  const onChangeTargetDate2 = async(date) => {
    const dt = moment(date, iFormat).format('YYYY-MM-DD')
    set_targetDate2(dt)
    if(targetDate == null) {
      set_targetDate(dt)
    }

  }


  const onView = () => {
    if(!smst?.id ) {
      alert('년도/기수가 선택되지 않았습니다.')
      return
    }

    if(smst.id === -1) {
      alert('년도/기수가 선택되지 않았습니다.')
      return
    }

    if(period === 1) {
      alert(period)
      if(!month) {
        alert('월이 선택되지 않았습니다.')
        return
      }
    }
    if(period === 2) {
      if(!targetDate) {
        alert('날짜가 선택되지 않았습니다.')
        return
      }
    }
    manyHandler[1](true)
  }

  const onLoad = async() => {
    const smstList = await fetchSmstList()
    set_smstList(smstList)
  }

  useEffect(() => {
    onLoad()
  }, [])

  useEffect(() => {
    if(smstList.length === 1) {
      set_smstId(smstList[0].id)
    }
  }, [smstList])

  useEffect(() => {
    onChangeSmstId(smstId)
  }, [smstId])

  return (
    <Fragment>
      {
        manyHandler[0] ? (
          <ManagerAttdncPartMany dialogHandler={manyHandler} smst={smst} 
            choice={{smst:smst, period:period, month:month, targetDate: targetDate, targetDate2: targetDate2, grade:grade, className:className, fillEmpty: fillEmpty, hidePhone: hidePhone}} 
          />
        ) : null 
      }
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='sm' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {schola.name} 
          </Typography>
          <Typography variant='body' align='center'>출석부 옵션</Typography>
          <Divider />
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{mt:1, mb:1}}>
              <InputLabel id='gisu' size='small'>
                년도/기수
              </InputLabel>
                  <Select
                    labelId='gisu'
                    required
                    label='년도/기수'
                    name={"smstId"}
                    value={smst?.id}
                    size='small'
                    onChange={async (e) => {
                      set_smstId(e.target.value)
                    }}>
                    {smstList.map((s, index) => {
                      return (
                        <MenuItem key={index} value={s.id}>
                          {s.year}/{s.gisu}
                        </MenuItem>
                      )
                    })}
                  </Select>
            </FormControl>
            <Grid container spacing={1} style={{marginTop: 5, marginBottom:15, }}>
              <Grid item xs={2}>
                <Typography style={{marginLeft:5}}>
                  기간: 
                </Typography>
              </Grid>
              <Grid item xs={10} style={{display:'flex', flexDirection:'row'}}>
                <label style={{marginRight:15, display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                    <input type='radio' 
                      name='period' 
                      checked={period=== 0}
                      onChange ={e => {
                        if(e.target.checked) {
                          set_period(0)
                        }
                      }}
                    /> <Typography variant='body2'>전체</Typography>
                </label>
                <label style={{marginRight:15, display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                    <input type='radio' 
                      name='period' 
                      checked={period === 1}
                      onChange ={e => {
                        if(e.target.checked) {
                          set_period(1)
                        }
                      }}

                    /> <Typography variant='body2'>월별</Typography>
                </label>
                <label style={{marginRight:15, display:'flex', flexDirection:'row', alignItems:'center'}}>
                  <input type='radio' 
                      name='period' 
                      checked={period=== 2}
                      onChange ={e => {
                        if(e.target.checked) {
                          set_period(2)
                        }
                      }}

                  /> <Typography variant='body2'>날짜별</Typography> 
                </label>

              </Grid>
            </Grid>
            {
              period == 1 ? (
                <FormControl fullWidth sx={{mt:1, mb:1}}>
                  <InputLabel id='month' size='small'>
                    월 선택  
                  </InputLabel>
                      <Select
                        labelId='month'
                        required
                        label='년월'
                        value={month}
                        size='small'
                        onChange={async (e) => {
                          set_month(e.target.value)
                        }}>
                        {monthList.map((m, index) => {
                          return (
                            <MenuItem key={index} value={m}>
                              {m}
                            </MenuItem>
                          )
                        })}
                      </Select>
                </FormControl>
              ) : null
            }
            {
              period === 2 ? (
              <>
                 <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"ko"}>
                   <DatePicker
                     label={"날짜선택(From)"}
                     value={targetDate}
                     inputFormat='YYYY-MM-DD'
                     onChange={(newValue) => {
                       const dtime = moment(new Date(newValue))
                       const d = dtime.format(iFormat)
                       onChangeTargetDate(d)
                     }}
                     renderInput={(params) => <TextField name={"targetDate"} fullWidth size='small' {...params} />}
                   />
                 </LocalizationProvider>
                 <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"ko"} >
                   <DatePicker
                     label={"날짜선택(To)"}
                     value={targetDate2}
                     inputFormat='YYYY-MM-DD'
                     onChange={(newValue) => {
                       const dtime = moment(new Date(newValue))
                       const d = dtime.format(iFormat)
                       onChangeTargetDate2(d)
                     }}
                     renderInput={(params) => <TextField name={"targetDate2"} fullWidth size='small' style={{marginTop:10}} {...params} />}
                   />
                 </LocalizationProvider>
              </>
              ) : null
          }
            <FormControl fullWidth sx={{mt:1, mb:1}}>
              <InputLabel id='grade' size='small'>
                학년 선택  
              </InputLabel>
                  <Select
                    labelId='grade'
                    required
                    label='학년'
                    value={grade}
                    size='small'
                    onChange={async (e) => {
                      set_grade(e.target.value)
                    }}>
                    {gradeList.map((m, index) => {
                      return (
                        <MenuItem key={index} value={m}>
                          {m}
                        </MenuItem>
                      )
                    })}
                  </Select>
            </FormControl>
            <FormControl fullWidth sx={{mt:1, mb:1}}>
              <InputLabel id='className' size='small'>
                반 선택  
              </InputLabel>
                  <Select
                    labelId='className'
                    required
                    label='반'
                    value={className}
                    size='small'
                    onChange={async (e) => {
                      set_className(e.target.value)
                    }}>
                    {classNameList.map((m, index) => {
                      return (
                        <MenuItem key={index} value={m}>
                          {m}
                        </MenuItem>
                      )
                    })}
                  </Select>
            </FormControl>
            <FormControl>
              <FormControlLabel
                    control={
                      <Checkbox 
                        color="primary"
                        onChange={e => {
                          set_hidePhone(e.target.checked)
                        }}
                        checked={
                          hidePhone
                        }
                      />
                    }
                    label={'학부모 전화번호 가리기'}
                />
            </FormControl>
            <FormControl>
              <FormControlLabel
                    control={
                      <Checkbox 
                        color="primary"
                        onChange={e => {
                          set_fillEmpty(e.target.checked)
                        }}
                        checked={
                          fillEmpty
                        }
                      />
                    }
                    label={'정원 미달 공란 채우기'}
                />
            </FormControl>
        </DialogContent>
        <DialogActions>
          <div style={{display:'flex', flex:1, flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
            <Button onClick={handleClose} style={{margin:5}}>닫기</Button>
            <Button onClick={onView} variant='contained' style={{margin:5}}>미리보기</Button>
          </div>
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
		
	)
}

export default ManagerAttdncPartChoice
